import React, { useMemo } from 'react';
import ModalCloseIcon from '@/components/general/ModalCloseIcon/ModalCloseIcon';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';

const Step = ({ number, label, active, onClick, disabled }) => {
  return (
    <FlexContainer
      className="flex-column align-items-center pointer"
      style={{ minWidth: 80 }}
      onClick={() => {
        if (!disabled && onClick) onClick();
      }}
    >
      <FlexContainer
        className="width-26px height-26px align-items-center justify-center text-12 index-2"
        style={{
          borderRadius: '50%',
          background: active ? '#6f8ec0' : '#ffffff',
          border: '3px solid #6f8ec0',
          boxShadow: active ? '0 2px 6px rgba(87,180,62,0.25)' : 'none',
          color: active ? '#fff' : '#000001',
          fontWeight: 800,
        }}
      >
        {number}
      </FlexContainer>

      <Label
        className="text-9 margt4 text-center width-150px"
        style={{ color: '#53595f', fontWeight: '700' }}
      >
        {label}
      </Label>
    </FlexContainer>
  );
};

const AgendaCitaConfirmacionModal = ({
  open,
  onClose,
  onConfirm,
  data,
  goStep1,
  goStep2,
  goStep3,
  currentStep,
  setCurrentStep,
  doctorServices = [],
  selectedService,
  selectService,
  isLoadingPersonal,
  patientInformation,
}) => {
  const { doctorName, specialty, dateFormatted, nombrePaciente } = useMemo(() => {
    if (!data) return {};

    const { doctor = {}, fecha = '' } = data;
    const dName = doctor?.abreviatura ? `${doctor.abreviatura} ${doctor.nombres}` : 'Dr. Prueba';

    const dFormatted = fecha
      ? new Date(fecha.replace(/-/g, '/')).toLocaleDateString('es-ES', {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
        })
      : 'Fecha no seleccionada';

    let nPaciente = 'Paciente prueba';
    try {
      const pacienteRaw = localStorage.getItem('user');
      if (pacienteRaw) {
        const pacienteObj = JSON.parse(pacienteRaw);
        nPaciente =
          `${pacienteObj.name || ''} ${pacienteObj.paterno || ''} ${
            pacienteObj.materno || ''
          }`.trim() || 'Paciente prueba';
      }
    } catch (e) {
      console.error('Error al parsear usuario:', e);
    }

    return {
      doctorName: dName,
      specialty: doctor?.especialidad || 'Especialidad prueba',
      dateFormatted: dFormatted,
      nombrePaciente: nPaciente,
    };
  }, [data]);
  if (!open) return null;

  return (
    <FlexContainer
      className="pos-fixed justify-center align-center"
      style={{
        inset: 0,
        background: 'rgba(0,0,0,0.45)',
        zIndex: 9999,
        padding: 20,
      }}
    >
      {isLoadingPersonal && (
        <>
          <div
            style={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              background: 'rgba(255,255,255,0.7)',
              zIndex: 10,
              borderRadius: '10px',
            }}
          >
            <div className="spinner" />
          </div>
        </>
      )}
      {!isLoadingPersonal && (
        <FlexContainer
          className="pos-rel flex-column width-680px m-format90 padtb26 padlr32 m-padlr20 modal-panel-with-footer"
          style={{
            borderRadius: '6px 6px 6px 6px',
            boxShadow: '0px 8px 22px rgba(0,0,0,0.15)',
            background: '#ffffff',
            maxHeight: 'calc(100vh - 24px)',
            height: 760,
          }}
        >
          <FlexContainer
            onClick={onClose}
            className="pos-abs pointer top16 right16 m-right20 width-38px height-38px text-22 align-items-center justify-center fontWhite index-3"
            style={{
              background: '#023B7A',
              borderRadius: '50%',
              fontWeight: 'bold',
              boxShadow: '0px 3px 6px rgba(2,59,122,0.3)',
            }}
          >
            <ModalCloseIcon />
          </FlexContainer>

          <div
            className="width-580px m-format100 m-margt18 bgWhite borderrad20 padtb16 padlr10 pos-rel margb20 left40 m-left0 top10"
            style={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
              minHeight: 0,
            }}
          >
            <FlexContainer className=" width100 margb8 justify-center m-hide" style={{ flexShrink: 0 }}>
              <FlexContainer className="align-items-center pos-rel">
                <FlexContainer
                  className="pos-abs left80 right80 top12 height-2px borderrad4 index-1"
                  style={{ background: '#6f8ec0' }}
                />

                <FlexContainer className="justify-between width100 index-2">
                  <Step
                    number={1}
                    label={'Especialidad'}
                    active={currentStep === 1}
                    onClick={goStep1}
                    disabled={false}
                  />
                  <Step
                    number={2}
                    label={'Médico'}
                    active={currentStep === 2}
                    onClick={goStep2}
                    disabled={false}
                  />
                  <Step
                    number={3}
                    label={'Fecha y Hora Disponibles'}
                    active={currentStep === 3}
                    onClick={goStep3}
                    disabled={false}
                  />
                  <Step
                    number={4}
                    label={'Confirmar Reserva de Cita'}
                    active={currentStep === 4}
                    onClick={() => setCurrentStep(4)}
                    disabled={false}
                  />
                </FlexContainer>
              </FlexContainer>
            </FlexContainer>

            <FlexContainer
              className="flex-column padlr50 m-padlr0 gap-12 my-custom-scroll"
              style={{
                flex: 1,
                minHeight: 0,
                overflowY: 'auto',
                overflowX: 'hidden',
                paddingRight: 6,
              }}
            >
              <FlexContainer className={'align-items-center gap-10 padtb0 margb8'}>
                <FlexContainer
                  className={'align-items-center width-24px height-24px justify-center pointer'}
                  style={{ borderRadius: '50%', border: '2px solid #6f8ec0' }}
                  onClick={goStep3}
                >
                  <span
                    className={'text-16 lineHeight-1'}
                    style={{ color: '#6f8ec0', fontWeight: 'bold' }}
                  >
                    ‹
                  </span>
                </FlexContainer>

                <div className={'text-16'} style={{ fontWeight: 600 }}>
                  <span style={{ color: '#023B7A' }}>
                    <strong>Agenda una cita |</strong>
                  </span>
                  <span style={{ color: '#6f8ec0', fontWeight: 500 }}> Elige tu especialidad</span>
                </div>
              </FlexContainer>

              <FlexContainer className="gap-12 align-items-center">
                <img
                  src="/images/user.png"
                  className="width-48px height-48px objectCover borderrad50"
                  alt="doctor"
                />
                <FlexContainer className="flex-column">
                  <Label className="text-16 fontBold" style={{ color: '#023B7A' }}>
                    <strong>{doctorName}</strong>
                  </Label>
                  <Label className="text-12" style={{ color: '#7b7b7b' }}>
                    {specialty}
                  </Label>
                </FlexContainer>
              </FlexContainer>

              <FlexContainer className="flex-column padlr60">
                <Label className="text-12 fontBold" style={{ color: '#7B7B7B' }}>
                  Paciente
                </Label>
                <Label className="text-16 fontBold" style={{ color: '#023B7A' }}>
                  <strong>
                    {patientInformation?.nombres +
                      ' ' +
                      patientInformation?.apellido_paterno +
                      ' ' +
                      patientInformation?.apellido_materno}
                  </strong>
                </Label>
              </FlexContainer>

              <div style={{ borderBottom: '1px solid #D9D9D9', width: '100%' }}></div>

              <FlexContainer className="gap-10 align-items-center padlr60">
                <i
                  className="fas fa-calendar-alt"
                  style={{ color: '#18489b', fontSize: '20px' }}
                ></i>
                <Label className="text-16" style={{ color: '#023B7A', fontWeight: 600 }}>
                  {dateFormatted}
                </Label>
              </FlexContainer>

              <FlexContainer className="flex-row gap-10 align-items-center padlr60">
                <i className="fas fa-clock" style={{ color: '#023B7A', fontSize: '20px' }}></i>
                <Label className="text-16" style={{ color: '#023B7A', fontWeight: 600 }}>
                  {data?.hora || 'Hora no seleccionada'}
                </Label>
              </FlexContainer>

              <FlexContainer className="flex-row gap-10 align-items-center padlr60 justify-between">
                <Label className="text-16" style={{ color: '#023B7A', fontWeight: 600 }}>
                  Tipo de Cita
                </Label>

                <select
                  value={selectedService?.codigo || ''}
                  className={'format100'}
                  onChange={(e) => {
                    const servicio = doctorServices.find(
                      (s) => String(s.codigo) === e.target.value,
                    );
                    if (servicio) {
                      selectService(servicio);
                      if (servicio?.titulo_de_tipo === 'TAMIZAJE DE CADERA DEL RECIEN NACIDO') {
                        alert(
                          'IMPORTANTE: Si tu menor hijo tiene más de 3 meses de nacido se sugiere realizar previamente una consulta médica.',
                        );
                      }
                    }
                  }}
                  style={{
                    padding: '6px 12px',
                    borderRadius: 8,
                    border: '1px solid #023B7A',
                    color: '#023B7A',
                    fontWeight: 600,
                    cursor: 'pointer',
                    outline: 'none',
                    backgroundColor: '#fff',
                  }}
                >
                  <option value="" disabled>
                    Seleccione tipo de cita
                  </option>
                  {doctorServices.map((servicio) => (
                    <option key={servicio.codigo} value={servicio.codigo}>
                      {servicio.titulo_de_tipo}
                    </option>
                  ))}
                </select>
              </FlexContainer>

              {selectedService && (
                <FlexContainer className="flex-row gap-10 align-items-center padlr60 justify-between">
                  <Label className="text-16" style={{ color: '#023B7A', fontWeight: 600 }}>
                    Precio
                  </Label>
                  <span style={{ color: '#023B7A', fontWeight: 600 }}>
                    S/ {selectedService?.costo_de_servicio}
                  </span>
                </FlexContainer>
              )}

              <FlexContainer className="gap-10 align-items-center padlr60">
                <i
                  className="fas fa-map-marker-alt"
                  style={{ color: '#023B7A', fontSize: '20px' }}
                ></i>
                <Label className="text-16" style={{ color: '#023B7A', fontWeight: 600 }}>
                  Jr. Junín 142, Miraflores 15038
                </Label>
              </FlexContainer>

              <div style={{ borderBottom: '1px solid #D9D9D9', width: '100%' }}></div>

              <FlexContainer
                className="bgLightBlue borderrad10 padt20 padlr40 padb20"
                style={{ background: '#F0F7FF' }}
              >
                <ul
                  className={'text-12 m-text-8'}
                  style={{ margin: 0, paddingLeft: 16, color: '#023B7A' }}
                >
                  <li
                    style={{
                      fontWeight: 'bold',
                      backgroundColor: '#FFF3CD',
                      padding: '8px 10px',
                      borderRadius: '6px',
                      marginBottom: '8px',
                      listStyle: 'none',
                      marginLeft: '-16px',
                    }}
                  >
                    La cita reservada debe pagarse al momento de la reserva o, como máximo, 48 horas
                    antes de la cita. De lo contrario, será cancelada por falta de pago.
                  </li>
                  <li>
                    Las cancelaciones o reprogramaciones con menos de 48 h de anticipación tendrán
                    una penalidad de S/50.
                  </li>
                  <li>
                    Si cuenta con resultados médicos, envíelos a{' '}
                    <strong>archivos@drq.com.pe</strong> 48 h antes.
                  </li>
                  <li>Se recomienda llegar con 10 minutos de anticipación.</li>
                  <li>La reserva de la cita implica el pago total de la misma.</li>
                </ul>
              </FlexContainer>
            </FlexContainer>

            <FlexContainer
              className="justify-center gap-12 padlr50 m-padlr0"
              style={{
                flexShrink: 0,
                paddingTop: 16,
                marginTop: 4,
                borderTop: '1px solid #E5EAF2',
                background: '#ffffff',
              }}
            >
              <button
                className="width-190px height-40px borderrad10 pointer"
                style={{
                  background: '#023B7A',
                  color: '#ffffff',
                  fontWeight: 700,
                  border: 'none',
                }}
                onClick={onClose}
              >
                Cancelar
              </button>
              {selectedService && (
                <button
                  className="width-190px height-40px borderrad10 pointer"
                  style={{
                    background: '#6f8ec0',
                    color: '#023B7A',
                    fontWeight: 700,
                    border: 'none',
                    boxShadow: '0px 2px 8px rgba(87,180,62,0.4)',
                  }}
                  onClick={onConfirm}
                >
                  Confirmar
                </button>
              )}
            </FlexContainer>
          </div>
        </FlexContainer>
      )}
    </FlexContainer>
  );
};

export default AgendaCitaConfirmacionModal;
